exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".widget-link.statusbar .widget-icon {\n  background-image: url(\"/content/plugin-statusbar/logo.svg\") !important;\n  opacity: 1 !important; }\n", ""]);

